import useSWR, { SWRConfiguration } from 'swr'; import hash from 'object-hash';
import { AxiosError } from 'axios';
import { OfferStatus } from '../../../domain/types';
import { Offer } from '../../../providers/api/dtos/offer';
import { getOffersByIntentId } from '../../../providers/api/offer/offerProvider';
import { SWRCustomResponse } from '../../../hooks/types';
import { useMatchMutate } from '../../../utils/swr/swr';

export const OFFERS_BY_INTENT_ID_RID = '/intents/:id/offers';

export default function useOffersByIntentId(
  intentId?: string,
  status?: OfferStatus | OfferStatus[],
  options?: SWRConfiguration<Offer[], AxiosError>,
): SWRCustomResponse<Offer[], AxiosError> {
  const matchMutate = useMatchMutate();

  const rid = [OFFERS_BY_INTENT_ID_RID, intentId].join();
  const key = intentId ? [
    rid,
    status ? hash(Array.isArray(status) ? [...status].sort() : { status }) : undefined,
  ] : null;
  const result = useSWR(key, () => getOffersByIntentId(intentId!, status), options);

  return {
    ...result,
    mutate: () => matchMutate(rid),
  };
}
